import { t } from 'i18next';

export function blank({ msg = t('validators.existential.blank') } = {}) {
  return (value: any) => {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return msg;
  };
}

export function required({ msg = t('validators.existential.required') } = {}) {
  return (value: any) => {
    if (value === undefined || value === null || value === '') {
      return msg;
    }
    return true;
  };
}
